import { useState, useCallback, useEffect } from "react";
import { useAuth } from "./useAuth";

export const useAccountStates = (accountId) => {
  const { apiClient } = useAuth();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(!!accountId);
  const [error, setError] = useState(null);

  const fetchAccountStates = useCallback(async () => {
    if (!accountId) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await apiClient.get(
        `accounts/${accountId}/signal-states/`,
      );
      setData(response.data);
    } catch (err) {
      console.error("Error fetching account states:", err);
      // Don't show error for 404 - means no data available
      if (err.response?.status === 404) {
        setData(null);
      } else if (err.response?.status !== 401) {
        setError("Failed to fetch account states");
      }
    } finally {
      setLoading(false);
    }
  }, [apiClient, accountId]);

  useEffect(() => {
    fetchAccountStates();
  }, [fetchAccountStates]);

  return {
    data,
    loading,
    error,
    refetch: fetchAccountStates,
  };
};
